import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import ListHeader from "@/common/components/ListHeader";
import Table from "@/common/components/Table";
import { DatePickerWithRange } from "@/common/components/ui/dateRangePicker";
import { dateToISOStingTransformer } from "@/common/utils/dateTransformer";
import { AreaChart } from "lucide-react";
import { useState } from "react";
import { DateRange } from "react-day-picker";
import ResumeList from "../../components/ResumeList";
import { totalizerFeesColumns, totalizerProductsColumns } from "../../constants/movementsTotalizerTableColumns.constant";
import { useMovementsTotalizer } from "../../hooks/useMovementsTotalizer";
import { MovementsTotalizerTransformer } from "../../services/movementsTotalizerTransformer";
import { MovementsTotalizerData } from "../../types/movementTotalizer.type";

const ProductPricesList = () => {
  const [date, setDate] = useState<DateRange | undefined>({
    from: undefined,
    to: undefined,
  });

  const {
    data: movementsTotalizer,
    isFetching: movementsTotalizerIsFetching,
    error: movementsTotalizerError = {} as any,
    refetch: refetchMovementsTotalizer,
  } = useMovementsTotalizer<MovementsTotalizerData>({
    filters: {
      startDate: dateToISOStingTransformer(date?.from),
      endDate: dateToISOStingTransformer(date?.to),
    },
  });

  return (
    <div className="flex flex-col gap-3">
      <div className="flex">
        <ListHeader
          Icon={<AreaChart className="w-10 h-10" strokeWidth={1.5} />}
          title="Totalizadores"
        />
      </div>

      <ErrorMessageWrapper
        className="max-h-[calc(100vh-128px)]"
        statusCode={movementsTotalizerError?.status}
        refetchFunction={refetchMovementsTotalizer}
      >

        <div className="flex flex-col gap-2">
          <div className="flex justify-between">
            <DatePickerWithRange
              date={date}
              setDate={setDate}
            />

            <ResumeList
              data={movementsTotalizer}
            />
          </div>
          
          <div className="flex flex-col flex-1 gap-2 max-h-[calc(100vh-160px)]">

            <div className="flex flex-col min-h-[165px]">
              <p>Produtos</p>
              <Table
                columns={totalizerProductsColumns}
                headerCellClassName="py-3"
                isLoadingData={movementsTotalizerIsFetching}
                rows={MovementsTotalizerTransformer.productsTableTransformer()(movementsTotalizer?.product_movements) || []}
                rowEmptyValue="--"
                page={1}
                totalPages={1}
                totalCount={movementsTotalizer?.product_movements?.length}
              />
            </div>

            <div className="flex flex-col min-h-[165px]">
              <p>Tarifas</p>
              <Table
                columns={totalizerFeesColumns}
                headerCellClassName="py-3"
                isLoadingData={movementsTotalizerIsFetching}
                rows={MovementsTotalizerTransformer.feesTableTransformer()(movementsTotalizer?.fees) || []}
                rowEmptyValue="--"
                page={1}
                totalPages={1}
                totalCount={movementsTotalizer?.fees?.length}
              />
            </div>

            <div className="flex flex-col min-h-[165px]">
              <p>Tarifas Especiais</p>
              <Table
                columns={totalizerFeesColumns}
                headerCellClassName="py-3"
                isLoadingData={movementsTotalizerIsFetching}
                rows={MovementsTotalizerTransformer.feesTableTransformer()(movementsTotalizer?.special_fees) || []}
                rowEmptyValue="--"
                page={1}
                totalPages={1}
                totalCount={movementsTotalizer?.special_fees?.length}
              />
            </div>

          </div>

        </div>
      </ErrorMessageWrapper>

    </div>
  );
};

export default ProductPricesList;